export class GCartesianChartLabel {
  show: boolean = false;
  minMargin: number;
  position: 'top' | 'bottom' | 'right' | 'left';
  formatter?: string | Function;

  constructor(init: Partial<GCartesianChartLabel>) {
    Object.assign(this, init);
  }
}
